// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__VDEes","btn":"styles_btn__1PoXc","btnRed":"styles_btnRed__2wdpR","btn_danger":"styles_btn_danger__31bXc","container":"styles_container__JWTCf"};